// src/components/CalendarView/calendarUtils.ts
import type { CalendarEvent } from './types';

// One item can yield several events for the same field name (one per layer),
// so ConversationId + CustomFieldName alone is not unique. Color stands in for
// the layer since CalendarEvent doesn't carry LayerId.
export function getCalendarEventKey(ev: CalendarEvent): string
{
  return `${ev.ConversationId}-${ev.CustomFieldName}-${ev.Color}-${ev.Date}`;
}

export function dedupeCalendarEvents(events: CalendarEvent[]): CalendarEvent[]
{
  const seen = new Set<string>();
  return events.filter(ev =>
  {
    const key = getCalendarEventKey(ev);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
